module.exports = __webpack_public_path__ + "static/img/jmnr20.39f07387.png";